import React from 'react';
import { motion } from 'framer-motion';
const painPoints = [{
  emoji: '😰',
  title: 'Te despertás a la noche con el corazón desbocado',
  desc: 'Sin saber si correr a urgencias o esperar.'
}, {
  emoji: '🏥',
  title: 'El ciclo de crisis no para nunca',
  desc: 'Se repite semana tras semana sin mejorar.'
}, {
  emoji: '😤',
  title: 'Le decís que no pasa nada y empeora',
  desc: 'Esa frase alimenta lo que querés curar.'
}, {
  emoji: '🗣️',
  title: 'No sabés qué palabras usar',
  desc: 'Necesitás un guión. No tenés uno.'
}, {
  emoji: '🛡️',
  title: 'Lo sobreprotegés sin querer',
  desc: 'Cada rescate hace el miedo más grande.'
}, {
  emoji: '💔',
  title: 'La culpa te consume',
  desc: 'No es falta de amor. Es falta de información.'
}, {
  emoji: '📚',
  title: 'El colegio no sabe cómo ayudarlo',
  desc: '6 horas sin vos sin ningún protocolo.'
}, {
  emoji: '📅',
  title: 'Cada semana improvisás de nuevo',
  desc: 'Sin sistema. Sin plan. Sin descanso.'
}];
export const PainPoints = () => {
  const scrollToPricing = () => document.getElementById('pricing')?.scrollIntoView({
    behavior: 'smooth'
  });
  return <section className="relative w-full bg-[#1A0A2E] py-12 sm:py-16 md:py-20 overflow-hidden" data-id="element-148">
      {/* Subtle pattern overlay */}
      <div className="absolute inset-0 opacity-[0.02] pointer-events-none" style={{
      backgroundImage: 'repeating-linear-gradient(45deg, #A855F7 0, #A855F7 1px, transparent 0, transparent 50%)',
      backgroundSize: '20px 20px'
    }} data-id="element-149" />

      <div className="relative z-10 mx-auto max-w-[720px] px-5" data-id="element-150">
        <div className="mb-12 text-center" data-id="element-151">
          <span className="mb-4 inline-block rounded-full bg-[#EDE9FF] px-3 py-1 text-xs font-bold uppercase tracking-wide text-[#6B21A8]" data-id="element-152">
            ¿TE IDENTIFICÁS?
          </span>
          <h2 className="font-heading text-3xl font-bold text-white sm:text-4xl md:text-5xl" data-id="element-153">
            Si tenés un hijo ansioso,
            <br data-id="element-154" />
            <span className="text-violet-gradient" data-id="element-155">
              esto te suena familiar:
            </span>
          </h2>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2" data-id="element-156">
          {painPoints.map((pain, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.05
        }} whileHover={{
          backgroundColor: '#3B1C6E',
          borderColor: '#D4A017'
        }} className="flex items-start gap-4 rounded-[16px] border-l-[3px] border-[#7C3AED] bg-[#2D1454] p-5 transition-colors duration-300" data-id="element-157">
              <div className="text-3xl flex-shrink-0" data-id="element-158">{pain.emoji}</div>
              <div data-id="element-159">
                <h3 className="mb-1 text-[15px] font-bold text-white" data-id="element-160">
                  {pain.title}
                </h3>
                <p className="text-[14px] leading-relaxed text-[#9B8EC4]" data-id="element-161">
                  {pain.desc}
                </p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mt-12 text-center sm:mt-16" data-id="element-162">
          <h3 className="mb-8 font-heading text-2xl font-bold text-white sm:text-3xl" data-id="element-163">
            ¿Cuántas semanas más sin un sistema?
          </h3>
          <motion.button onClick={scrollToPricing} whileHover={{
          y: -2
        }} whileTap={{
          scale: 0.98
        }} className="mx-auto flex h-[68px] w-full max-w-[560px] items-center justify-center rounded-[14px] bg-violet-gradient px-6 text-[18px] font-bold uppercase tracking-wide text-white shadow-btn-violet sm:text-[20px]" data-id="element-164">
            💥 Quiero Calmar la Ansiedad de Mi Hijo Ahora
          </motion.button>
        </motion.div>
      </div>
    </section>;
};